/** @format */

import React from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CardIcon from '../../components/Card/CardIcon';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardBody from '../../components/Card/CardBody';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import NumberRangeEditForm from './NumberRangeEditForm';
import NumberRangeList from './NumberRangeList';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import { NumberRange } from '../../interfaces/platform/NumberRange';
import { useParams } from 'react-router-dom';

const NumberRangeEdit = (): React.ReactElement => {
    const [value, setValue] = React.useState<number>(0);
    const [activeNumberRange, setActiveNumberRange] = React.useState<NumberRange | null>(null);
    const { platformResellerId } = useParams();

    console.log(useParams());

    const changeActiveTab = (params: { index: number }): void => {
        setValue(params.index);
        setActiveNumberRange(null);
    };

    const editExistingRange = (numberRange: NumberRange): void => {
        setValue(1);
        setActiveNumberRange(numberRange);
    };

    return (
        <Card>
            <CardHeader icon>
                <CardIcon color={'info'}>
                    <MenuBookIcon />
                </CardIcon>
            </CardHeader>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12}>
                        <CustomTextButtom callback={changeActiveTab} callbackParam={{ index: 0 }} label="number_range:h.number_range_list" />
                        <CustomTextButtom callback={changeActiveTab} callbackParam={{ index: 1 }} label="number_range:h.number_range_add" />

                        {value === 0 && (
                            <GridItem xs={12}>
                                <NumberRangeList platformResellerId={platformResellerId} editExistingRange={editExistingRange} />
                            </GridItem>
                        )}

                        {value === 1 && (
                            <GridItem xs={6}>
                                <NumberRangeEditForm platformResellerId={platformResellerId} activeNumberRange={activeNumberRange} />
                            </GridItem>
                        )}
                    </GridItem>
                </GridContainer>
            </CardBody>
        </Card>
    );
};

export default NumberRangeEdit;
